import React from 'react';
import { Grid } from '@material-ui/core';
import {
  string,
  node,
  objectOf,
  oneOfType,
  number,
} from 'prop-types';
import DefaultContainer from '../../DefaultContainer';
import DefaultParagraph from '../../../typeface/DefaultParagraph';
import styles from './style.module.scss';

const QuoteSection = ({
  children,
  className,
  style,
  fullName,
  profession,
}) => (
  <DefaultContainer
    style={style}
    className={[styles.container, className].join(' ')}
    justify="center"
  >
    <Grid item md={8}>
      <Grid container direction="row">
        <h4 className={styles.quote}>{`"${children}"`}</h4>
        <Grid container justify="flex-end">
          <Grid item style={{ marginTop: 16 }}>
            <DefaultParagraph className={styles.name}>{fullName}</DefaultParagraph>
            <DefaultParagraph className={styles.profession}>{profession}</DefaultParagraph>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </DefaultContainer>
);

QuoteSection.propTypes = {
  className: string,
  children: node,
  fullName: string,
  profession: string,
  style: objectOf(oneOfType([
    string,
    number,
  ])),
};

QuoteSection.defaultProps = {
  className: null,
  children: null,
  fullName: null,
  profession: null,
  style: null,
};

export default QuoteSection;
